/** D4 - integers everywhere; fixed point at FP_ONE; probabilities in basis points. */

export const FP_ONE = 1000;
export const BP_ONE = 10000;

/** Round half away from zero. The single rounding point (D4). */
export function roundHalfAway(x: number): number {
  return x < 0 ? -Math.round(-x) : Math.round(x);
}

/** a * (b / FP_ONE), rounded once. */
export function mulFp(a: number, b: number): number {
  return roundHalfAway((a * b) / FP_ONE);
}

export function clampInt(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

/** Percent as a fixed-point multiplier: 25 becomes 1250, i.e. times 1.25. */
export const pctToFp = (pct: number): number => FP_ONE + roundHalfAway((pct * FP_ONE) / 100);
